import styled from "styled-components";
import Nav from "../components/nav/Nav";
import React, { useState } from "react";

const FunctionalPage = ({ component: Component, title }) => {
  const [navIsOpen, setNavIsOpen] = useState(false);

  const capitalizeTitle = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <Page>
      <Nav setNavIsOpen={setNavIsOpen} navIsOpen={navIsOpen} />

      {title && <H1> {capitalizeTitle(title)} </H1>}

      <Container>{Component}</Container>
    </Page>
  );
};

const H1 = styled.h1`
  @media print {
    display: none;
  }
`;

const Page = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;

  h1 {
    text-align: center;
  }

  .add-btn {
    width: 200px;
    align-self: center;
  }
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 0.5rem;
  height: 100%;
  @media (min-width: 1224px) {
    padding: 0 1rem;
  }
  @media (min-width: 1600px) {
    width: 1600px;
  }
`;

export default FunctionalPage;
